import { Box, IconButton, Typography } from '@mui/material';
import { SxProps, Theme, useTheme } from '@mui/material/styles';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { getMMMMYYYYFromString, getYYYYMFromString } from '../../shared/functions/dateProcessor';
interface MonthSelectorProps {
  disabled: boolean;
  currMonth: string;
  onMonthChange: (month: string) => void;
  containerSx?: SxProps<Theme>;
  labelContainerSx?: SxProps<Theme>;
  labelSx?: SxProps<Theme>;
  buttonSx?: SxProps<Theme>;
}

export default function MonthSelector(props: Readonly<MonthSelectorProps>) {
  const { disabled, currMonth, onMonthChange, containerSx, labelContainerSx, labelSx, buttonSx } = props;
  const theme = useTheme();

  const handleClickNextMonth = () => {
    const nextMonth = getYYYYMFromString(currMonth, 1);
    onMonthChange(nextMonth);
  };

  const handleClickPrevMonth = () => {
    const prevMonth = getYYYYMFromString(currMonth, -1);
    onMonthChange(prevMonth);
  };

  return (
    <Box
      sx={
        [
          { display: 'flex', alignItems: 'center', gap: '10px' },
          ...(containerSx ? [containerSx] : []),
        ] as SxProps<Theme>
      }
    >
      <IconButton
        disabled={disabled}
        sx={
          [
            {
              backgroundColor: theme.palette.whiteScaleDark.main,
              borderRadius: 1,
              padding: 0,
              '&:hover': {
                backgroundColor: theme.palette.whiteScaleDarker.main,
              },
            },
            ...(buttonSx ? [buttonSx] : []),
          ] as SxProps<Theme>
        }
        size="small"
        onClick={() => handleClickPrevMonth()}
        data-cy="tracker-table-month-selector-prev-month"
      >
        <ChevronLeftIcon sx={{ color: theme.palette.whiteScale.contrastText, fontSize: 24 }} />
      </IconButton>
      <Box sx={[{ width: '150px' }, ...(labelContainerSx ? [labelContainerSx] : [])] as SxProps<Theme>}>
        <Typography variant="h6" sx={labelSx}>
          {disabled ? 'Filter View' : getMMMMYYYYFromString(currMonth)}
        </Typography>
      </Box>

      <IconButton
        disabled={disabled}
        sx={
          [
            {
              backgroundColor: theme.palette.whiteScaleDark.main,
              borderRadius: 1,
              padding: 0,
              '&:hover': {
                backgroundColor: theme.palette.whiteScaleDarker.main,
              },
            },
            ...(buttonSx ? [buttonSx] : []),
          ] as SxProps<Theme>
        }
        size="small"
        onClick={() => handleClickNextMonth()}
        data-cy="tracker-table-month-selector-next-month"
      >
        <ChevronRightIcon sx={{ color: theme.palette.whiteScale.contrastText, fontSize: 24 }} />
      </IconButton>
    </Box>
  );
}
